module.exports = __webpack_public_path__ + "static/media/heart1.a93833bf.svg";